<template>
  <div class="configuration-code-container">
    <span style="margin-right: 0.25em"
      >{{ i18n.t('/Configuration/ConfigurationCode') }}: {{ configurationCode }}</span
    >
    <configuration-code-form :disabled="isButtonDisabled" :order-service="orderService" />
    <app-button
      :disabled="isButtonDisabled"
      style="margin-left: 0.25em"
      data-qa="edit-configuration-button"
      @click="openConfigurator"
      >{{ i18n.t('/Configuration/EditConfiguration') }}</app-button
    >
    <app-button
      v-if="isDealerConfiguratorButtonVisible"
      :disabled="isButtonDisabled"
      style="margin-left: 0.25em"
      data-qa="edit-dealer-configuration-button"
      @click="openDealerConfigurator"
    >
      {{ i18n.t('/Configuration/DealerConfiguratorButtonText') }}
    </app-button>
  </div>
</template>

<script>
import ConfigurationCodeForm from '@/components/generic/presentational/organisms/configurationCodeForm/ConfigurationCodeForm.vue'
import quoteOrderService from '@/services/quoteOrderService.js'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    ConfigurationCodeForm,
    AppButton,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      orderService: quoteOrderService,
      isSaving: false,
    }
  },
  computed: {
    isButtonDisabled() {
      return [this.isSaving, !this.quoteId, this.quoteStatusIsSalesOrder].some(Boolean)
    },
    isDealerConfiguratorButtonVisible() {
      return this.i18n.translationExists('/Configuration/DealerConfiguratorEditUrl')
    },
    formattedUrl() {
      let url = this.i18n.t('/Configuration/ConfiguratorEditUrl', {
        configurationCode: this.configurationCode,
        quoteId: this.quoteId,
        returnUrl: encodeURIComponent(this.callbackUrl),
      })

      return url
    },
    formattedDealerUrl() {
      let url = this.i18n.t('/Configuration/DealerConfiguratorEditUrl', {
        configurationCode: this.configurationCode,
        quoteId: this.quoteId,
        returnUrl: encodeURIComponent(this.callbackUrl),
      })

      return url
    },
    callbackUrl() {
      // for use Vue router (b2b and soon b2c)
      if (this.$router) {
        const url = this.$router.resolve({
          name: 'configuration-page',
          ...this.$route.params,
        })
        return `${window.location.origin}${url.href}`
      } else {
        // for normal cst
        return `${window.location.origin}/klantconfiguratie`
      }
    },
    ...mapGetters({
      quoteId: 'quote/quoteId',
      configurationCode: 'configuration/configurationCode',
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
    }),
  },
  methods: {
    ...mapActions({ updateQuote: 'quote/update' }),
    async openConfigurator() {
      await this.openLink(this.formattedUrl)
    },
    async openDealerConfigurator() {
      await this.openLink(this.formattedDealerUrl)
    },
    async openLink(url) {
      const urlTarget = this.i18n.t('/Configuration/ConfiguratorUrlTarget')
      this.isSaving = true
      // first save the quote to not lose any changes.
      await this.updateQuote()

      this.isSaving = false
      if (urlTarget == '_blank') {
        window.open(url)
      } else {
        location.href = url
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.configuration-code-container {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  justify-content: flex-end;
}
</style>
